<app-simple-modal [title]="edit?'Editar contraseña':'Agregar contraseña'" [max]="50" (close)="close.emit($event)">
	<div fields>
		<div class="form-group" *ngIf="!edit">
			<label for="company" class="form-label">Empresa <i class="fa fa-asterisk text-danger"></i></label>
			<div class="input-group">
				<app-input-autocomplete (changeStatus)="selectCompany($event.filterElement)"
					(inputMethod)="searchCompany()" [allBorderRadius]="true" [filterElements]="companies"
					[placeholder]="'Busca una empresa'" [custom]="true" [inputs]="inputs">
					<ng-template #itemsTemplate let-filter>
						<!-- This is the content that will be projected -->
						<div items>
							<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
								{{filter.companyName?filter.companyName:filter.name}}</h5>
							<span class="text-muted" style="color: white !important;">{{filter.alphanumericId}} -
								NIT: <b>{{filter.companyNIT?filter.companyNIT:filter.nit}}</b></span>
						</div>
					</ng-template>
				</app-input-autocomplete>
			</div>
		</div>
		<div class="form-group" *ngIf="edit">
			<label for="editCompany" class="form-label">Empresa <i class="fa fa-asterisk text-danger"></i></label>
			<input type="text" disabled [value]="edit.name" placeholder="Ingresa la contraseña" name="editCompany" id="editCompany"
				class="form-control">
		</div>
		<div class="form-group" style="margin-bottom: 1em;">
			<label for="password" class="form-label">Contraseña <i class="fa fa-asterisk text-danger"></i></label>
			<input type="password" placeholder="Ingresa la contraseña" name="password" id="password"
				class="form-control" [(ngModel)]="newPassword" autocomplete="new-password">
		</div>
		<div class="form-group">
			<label for="confirm-password" class="form-label">Confirmación <i class="fa fa-asterisk text-danger"></i></label>
			<input type="password" class="form-control" name="confirm-password" id="confirm-password"
				autocomplete="new-password" [(ngModel)]="confirmPassword" placeholder="Ingresa de nuevo la contraseña">
			<span class="form-text text-muted" *ngIf="confirmPassword 
				&& newPassword 
				&& confirmPassword != newPassword">
				<i class="fa fa-circle-info"></i> Las contraseñas deben de coincidir
			</span>
		</div>
	</div>
	<div buttons>
		<app-loading-button [object]="buttonSave" (clicked)="savePassword()"
			[disabled]="(!edit && !selected) || !newPassword || !confirmPassword || newPassword != confirmPassword">
		</app-loading-button>
	</div>
</app-simple-modal>